// extracted by mini-css-extract-plugin
module.exports = {"darkBackground":"_3mDTw","root":"_3VU64","title":"_3Kg4q","paragraph":"_1a1vP"};